import React, { useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import { MDBBtn, MDBModal, MDBModalBody, MDBModalHeader } from "mdbreact";
import { GGgetMode } from "../../services/gglocalstorage";
import BotaoIngressoCurso from "../BotaoIngressoCurso/BotaoIngressoCurso";
import "./InvestimentoCurso.css";

export default function InvestimentoCurso({ curso, cursoSelecionado, isMedicina = false, cursoEspecial = false }) {
	const [showModal, setShowModal] = useState(false);
	const titulo = cursoSelecionado?.Title;

	const TabelaGestao = () => (
		<>
			<table className="table">
				<thead className="text-center">
					<tr>
						<th>Ano</th>
						<th>Valor da Mensalidade</th>
						<th>Meses</th>
					</tr>
				</thead>
				<tbody className="text-center">
					<tr>
						<td>1º</td>
						<td>R$ 299,90</td>
						<td>12</td>
					</tr>
					<tr>
						<td>2º</td>
						<td>R$ 399,90</td>
						<td>12</td>
					</tr>
					<tr>
						<td>3º</td>
						<td>R$ 499,90</td>
						<td>12</td>
					</tr>
				</tbody>
			</table>
			<hr />
			<p style={{ fontSize: "small" }}>
				Valor mensal e referente ao total de componentes curriculares que
				compõem cada módulo. Cada trimestre é composto por três mensalidades.
				<br />
				<br />
				Obs.: Os valores das mensalidades estarão sujeitos a reajustes anuais,
				conforme índices praticados pela instituição.
				<br />
				<br />
				<a
					href="https://www.feevale.br/s/conteudo/9a315c7e-00d3-4ebb-aed0-32c7d13f10e2/Regulamento_06.2025_Valores_EAD.pdf"
					target="_blank"
				>
					Veja o Regulamento
				</a>
			</p>
		</>
	);

	const TabelaBacharelado = () => (
		<>
			<table className="table">
				<thead className="text-center">
					<tr>
						<th>Ano</th>
						<th>Valor da Mensalidade</th>
						<th>Meses</th>
					</tr>
				</thead>
				<tbody className="text-center">
					<tr>
						<td>1º</td>
						<td>R$ 299,90</td>
						<td>12</td>
					</tr>
					<tr>
						<td>2º</td>
						<td>R$ 459,90</td>
						<td>12</td>
					</tr>
					<tr>
						<td>3º</td>
						<td>R$ 590,50</td>
						<td>12</td>
					</tr>
					<tr>
						<td>4º</td>
						<td>R$ 599,50</td>
						<td>12</td>
					</tr>
				</tbody>
			</table>
			<hr />
			<p style={{ fontSize: "small" }}>
				Valor mensal e referente ao total de componentes curriculares que
				compõem cada módulo. Cada trimestre é composto por três mensalidades.
				<br />
				<br />
				Obs.: Os valores das mensalidades estarão sujeitos a reajustes anuais,
				conforme índices praticados pela instituição.
				<br />
				<br />
				<a
					href="https://www.feevale.br/s/conteudo/9a315c7e-00d3-4ebb-aed0-32c7d13f10e2/Regulamento_06.2025_Valores_EAD.pdf"
					target="_blank"
				>
					Veja o Regulamento
				</a>
			</p>
		</>
	);

	const TabelaTecnologo = () => (
		<>
			<table className="table">
				<thead className="text-center">
					<tr>
						<th>Ano</th>
						<th>Valor da Mensalidade</th>
						<th>Meses</th>
					</tr>
				</thead>
				<tbody className="text-center">
					<tr>
						<td>1º</td>
						<td>R$ 299,90</td>
						<td>12</td>
					</tr>
					<tr>
						<td>2º</td>
						<td>R$ 381,71</td>
						<td>12</td>
					</tr>
					<tr>
						<td>Parcelamento estendido</td>
						<td>R$ 381,71</td>
						<td>6</td>
					</tr>
				</tbody>
			</table>
			<hr />
			<p style={{ fontSize: "small" }}>
				Valor mensal e referente ao total de componentes curriculares que
				compõem cada módulo. Cada trimestre é composto por três mensalidades.
				<br />
				<br />
				Obs.: Os valores das mensalidades estarão sujeitos a reajustes anuais,
				conforme índices praticados pela instituição.
				<br />
				<br />
				<a
					href="https://www.feevale.br/s/conteudo/9a315c7e-00d3-4ebb-aed0-32c7d13f10e2/Regulamento_06.2025_Valores_EAD.pdf"
					target="_blank"
				>
					Veja o Regulamento
				</a>
			</p>
		</>
	);

	function getValor() {
		let campoInvestimento = cursoSelecionado.Informacoes?.Investimento?.Value;
		// Caso o curso tenha informações de investimento registradas.
		if (typeof campoInvestimento === "string" && campoInvestimento.trim() !== "") {
			let htmlValores;
			if (GGgetMode()) {
				htmlValores = campoInvestimento
					.replaceAll("text-primary", "text-secondary")
					.replaceAll("bg-primary", "bg-white")
					.replaceAll("white-text", "text-dark");
			} else {
				htmlValores = campoInvestimento;
			}

			return (
				<>
					<div
						className={GGgetMode() && "text-white"}
						dangerouslySetInnerHTML={{
							__html: htmlValores.replace(/secondary/g, "primary"),
						}}
					></div>

					{!isMedicina && (
						<div>
							<a
								href="https://www.feevale.br/s/conteudo/0ca88ebc-a880-44ff-89de-1d25613291a4/Regulamento_06.2026_Gradua%c3%a7%c3%a3o_presencial_e_semipresencial.pdf"
								target="_blank"
							>
								{" "}
								Veja o Regulamento
							</a>
						</div>
					)}
				</>
			);
		}

		// Caso seja EAD ou Semipresencial, utiliza a tabela de modalidades.
		if (
			cursoSelecionado.Informacoes?.Modalidade?.Value === "EAD" ||
			cursoSelecionado.Informacoes?.Modalidade?.Value === "Semipresencial"
		) {
			return (
				<>
					<div className="investimentoCurso-ead-grid">
					<div className="investimentoCurso-ead-card" id="mensalidade">
						<h2 className="investimentoCurso-ead-label">Mensalidade do 1º ano</h2>
						<strong className="investimentoCurso-ead-valor">
							{titulo ===
														"Gestão da Produção Industrial - Tecnólogo - EaD"
															? "R$ 299,90" // Valor curso semipresencial
															: [
																	{
																		modalidade: "Licenciatura",
																		valor: "R$ 299,90",
																	},
																	{
																		modalidade: "Tecnologo",
																		valor: "R$ 299,90",
																	},
																	{
																		modalidade: "Bacharelado",
																		valor: "R$ 299,90",
																	},
															  ].find(
																	(i) =>
																		i.modalidade ===
																		cursoSelecionado.Informacoes?.Tipo?.Value
															  )?.valor || "R$ 299,90"}
						</strong>
						<button
							type="button"
							className="investimentoCurso-ead-botao"
							onClick={() => setShowModal(true)}
						>
							Saiba como funcionam as mensalidades{" "}
							<i className="fas fa-arrow-right" aria-hidden="true" />
						</button>
					</div>
					<div className="investimentoCurso-ead-informacoes">
						<p>
						Valor mensal e referente ao total de componentes curriculares
						que compõem cada módulo.
						<br />
						Cada trimestre é composto por três mensalidades.
						<br />
						<br />
						Obs.: Os valores das mensalidades estarão sujeitos a reajustes
						anuais, conforme índices praticados pela instituição.
						<br />
						<br />
						<a
						href="https://www.feevale.br/s/conteudo/9a315c7e-00d3-4ebb-aed0-32c7d13f10e2/Regulamento_06.2025_Valores_EAD.pdf"
						target="_blank"
						>
						Veja o Regulamento
						</a>
						</p>
					</div>
				</div>
				<MDBModal
						isOpen={showModal}
						toggle={() => setShowModal(false)}
						centered
					>
						<MDBModalHeader toggle={() => setShowModal(false)}>
							Tabela de Valores
						</MDBModalHeader>
						<MDBModalBody>
							{titulo === "Gestão da Produção Industrial - Tecnólogo - EaD" ? (
								<TabelaGestao />
							) : cursoSelecionado.Informacoes?.Tipo?.Value ===
							  "Bacharelado" ? (
								<TabelaBacharelado />
							) : (
								<TabelaTecnologo />
							)}
						</MDBModalBody>
					</MDBModal>
				</>
			);
		}

		// Caso utilize o simulador financeiro
		//return <SimuladorFinanceiro />;
		const cursoEspecial =
			curso?.Items?.[0]?.Informacoes?.Associacao?.Value ===
				"Letras - Português/Inglês" ||
			curso?.Items?.[0]?.Informacoes?.Associacao?.Value === "História";

		return (
			<>
				{cursoEspecial ? (
					<div className="text-center">
						<h1 className="text-primary">Ingresso Especial</h1>
						<p>Participe do Programa Professor do Amanhã</p>
						<MDBBtn
							className="animated-button-top saira-title"
							href="https://feevale.apprbs.com.br/professor-do-amanha/"
							target="_blank"
						>
							Professor do Amanhã
						</MDBBtn>
					</div>
				) : (
					<div className="text-center px-5 mx-5">
						<h1 className="text-primary">Investimento</h1>
						<MDBBtn
							className="btn-white btn-outline-primary font-weight-bold d-block mx-5 my-5"
							href="https://www.feevale.br/institucional/ingresso/beneficios#simuladorFinanceiro"
							target="_blank"
						>
							Saiba mais
						</MDBBtn>
					</div>
				)}
			</>
		);
	}

	return (
		<Container id="investimento" className="investimentoCurso">
					<div className="investimentoCurso-inscricao mb-5">
						<BotaoIngressoCurso
							modalidade={
								cursoSelecionado?.Informacoes?.Modalidade?.Value
							}
							isMedicina={isMedicina}
							cursoEspecial={cursoEspecial}
						/>
					</div>
					<div className="investimentoCurso-corpo">{getValor()}</div>
					<Row>
						{!cursoEspecial && (
							<Col md="12" className="font-italic mt-3">
								*Valores válidos para 2026. As matrículas contratadas em 2026 relativas ao ano de 2027 estão sujeitas ao reajuste de mensalidade conforme disposto na Lei nº 9.870 de 23/11/1999. Eventual diferença de valor será acrescida nas parcelas posteriores.
							</Col>
						)}
					</Row>
					</Container>
	);
}
